import { isFunction, isNil } from 'swipeclock-frontend';

// NOTE: In order to make sure cache works
// You must pass in correct defaults for the query

/**
 * Example:
    const { promise, unsubscribe } = dispatchEndpoint(store, billingApi.endpoints.createStripeCustomer, {
        ensemblesId: selectedCompany.ensembles_id,
    });

    // When you need to unsubscribe:
    unsubscribe();
 */
export function dispatchEndpoint(
  dispatch,
  endpoint,
  params,
  forceRefetch = false
) {
  let promise;

  if (isNil(params)) {
    promise = dispatch(endpoint.initiate(undefined, { forceRefetch }));
  } else {
    promise = dispatch(endpoint.initiate(params, { forceRefetch }));
  }

  return {
    promise,
    unsubscribe: () => promise.unsubscribe(),
  };
}

/**
 * Example:
 * const data = await dispatchAndUnwrap(
 *    dispatch, masterDataApi.endpoints.getMasterDataCompany,
 *    { siteId: user?.site }
 * );
 */
export async function dispatchAndUnwrap(
  dispatch,
  endpoint,
  params,
  forceRefetch = false
) {
  try {
    let response;
    if (isNil(params)) {
      response = dispatch(
        endpoint.initiate(null, { forceRefetch: forceRefetch })
      );
    } else {
      response = dispatch(
        endpoint.initiate(params, { forceRefetch: forceRefetch })
      );
    }
    if (isFunction(response.unsubscribe)) {
      response.unsubscribe();
    }
    return await response.unwrap();
  } catch (error) {
    console.error('Error in dispatchAndUnwrap:', error);
    throw error;
  }
}
